














import { Component, Prop, Vue } from "vue-property-decorator";
import { PlayerType } from "@/types";

export type TagSizeType = "small" | "medium" | "normal" | "large";

@Component
export default class PlayerTag extends Vue {
  @Prop({ default: false }) active?: boolean;
  @Prop({ required: false }) color?: string;
  @Prop({ required: false }) extra?: string | number;
  @Prop({ default: false }) full?: boolean;
  @Prop({ required: false }) onClick?: (id: string) => void;
  @Prop({ required: false, default: false }) outlined?: boolean;
  @Prop({ required: true }) player!: PlayerType;
  @Prop({ default: "normal" }) size!: TagSizeType;

  handleClick() {
    if (!this.onClick) return;
    this.onClick(this.player.id);
  }
}
